<script>
    import router from "page";
    import { onMount, onDestroy } from "svelte";

    import Tabulator from "tabulator-tables";
    import "tabulator-tables/dist/css/tabulator.min.css";

    import { fetchGet } from "../utils/utilsFetch.js";

    import { addToCartFormatter } from "../utils/utilsTabulator.js";

    import {
        productPictureLinkFormatter,
        numberFormatter,
        oneDecimalFormatter,
        percentFormatter,
        keywordFilter,
        openProductModal,
    } from "../utils/utilsTabulator.js";

    import { isLoading, searchInput, client, locale } from "../stores.js";

    export let querystring;

    let products = [],
        table,
        tableElement;

    let title;

    onDestroy(() => {
        $searchInput = null;
    });

    async function getProducts(querystring) {
        $isLoading = true;

        console.log("querystring", querystring);

        let urlParams = new URLSearchParams(window.location.search);

        let category = urlParams.get("category");
        let brand = urlParams.get("brand");
        let search = urlParams.get("search");
        let view = urlParams.get("view");

        if (category) {
            title = `${$locale.categoryLabel || ""}: ${category}`;
        }

        if (brand) {
            title = `${$locale.brandLabel || ""}: ${brand}`;
        }

        if (search) {
            title = `${$locale.searchLabel || ""}: ${search}`;
        }

        if (view == "pricelist") {
            title = `${$locale.pricelist || ""}`;
        }

        products = await fetchGet(`/api/products?${querystring}`);
        console.log(products);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: products,
            layout: "fitDataFill",
            cellVertAlign: "middle",
            index: "sku",
            columns: [
                {
                    title: "",
                    field: "sku",
                    formatter: productPictureLinkFormatter,
                },
                {
                    title: $locale.sku || "",
                    field: "sku",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                    formatter: (cell, formatterParams, onRendered) => {
                        cell.getElement().style.fontWeight = "bold";
                        return cell.getValue();
                    },
                    cellClick: openProductModal,
                },
                {
                    title: $locale.product || "",
                    field: "productName",
                    width: $client.isHiddenPrices ? 600 : 300,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                    formatter: (cell, formatterParams, onRendered) => {
                        cell.getElement().style.fontWeight = "bold";
                        return cell.getValue();
                    },
                    cellClick: openProductModal,
                },
                {
                    title: $locale.vat || "",
                    field: "vat",
                    formatter: percentFormatter,
                },
                {
                    title: $locale.price || "",
                    columns: [
                        {
                            title: $locale.withoutVat || "",
                            field: "priceWithoutVat",
                            formatter: oneDecimalFormatter,
                        },
                        {
                            title: $locale.withVat || "",
                            field: "priceWithVat",
                            formatter: oneDecimalFormatter,
                        },
                    ],
                },
                {
                    title: $locale.yourPrice || "",
                    columns: [
                        {
                            title: $locale.discount || "",
                            field: "discount",
                            formatter: percentFormatter,
                        },
                        {
                            title: $locale.withoutVat || "",
                            field: "clientPriceWithoutVat",
                            formatter: (cell, formatterParams, onRendered) => {
                                if (cell._cell.row.data.isCustomPrice) {
                                    cell.getElement().style.background =
                                        "rgba(255, 255, 0, 0.5)";
                                }

                                return cell.getValue();
                            },
                        },
                        {
                            title: $locale.withVat || "",
                            field: "clientPriceWithVat",
                            formatter: oneDecimalFormatter,
                        },
                    ],
                },
                {
                    title: $locale.stock || "",
                    field: "stockHidden",
                    formatter: (cell) => {
                        let stock = cell.getValue().split(".")[0];

                        if (stock == ($locale.noStock || "Нема")) {
                            cell.getElement().style.color = "red";
                        }

                        return stock;
                    },
                },
                {
                    title: $locale.packaging || "",
                    field: "packaging",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.barcode || "",
                    field: "barcodes",
                    width: 200,
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                },
                {
                    title: $locale.order || "",
                    frozen: true,
                    formatter: addToCartFormatter,
                },
            ],
        });

        if ($client.isHiddenPrices) {
            table.hideColumn("vat");
            table.hideColumn("priceWithoutVat");
            table.hideColumn("priceWithVat");
            table.hideColumn("discount");
            table.hideColumn("clientPriceWithoutVat");
            table.hideColumn("clientPriceWithVat");
        }

        $isLoading = false;
    }

    $: getProducts(querystring);
</script>

<div class="container">
    <div class="header"><b>{title}</b></div>

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .table {
        border-radius: 3px;
    }
</style>
